import { Link } from "react-router-dom";
import React from "react";
import styles from "./navigation.module.scss";
import LoginSignUp from "../../common/LoginSignUp/LoginSignUp";

const Navigation = () => {
  return (
    <div className={styles.container}>
      <div className={styles.leftWrapper}>
        <div className={styles.leftContainer}>
        <Link to="/">
          <img className={styles.logo} src="/assets/nav-logo.svg" /> </Link>
          <div className={styles.leftMenuWrapper}>
            <Link to="/wallet">
              <div className={styles.menuItem}>Wallet</div>
            </Link>
            <Link to="/exchange">
              <div className={styles.menuItem}>Exchange</div>
            </Link>
          </div>
        </div>
      </div>
      <LoginSignUp />
    </div>
  );
};

export default Navigation;
